import type { IconSvgObject } from './types';

const Brain03Icon: IconSvgObject = [
  ["path", { d: "M12 19V5C12 3.34315 10.6569 2 9 2C7.34315 2 6 3.34315 6 5V6H5C3.34315 6 2 7.34315 2 9C2 10.6569 3.34315 12 5 12C3.34315 12 2 13.3431 2 15C2 16.6569 3.34315 18 5 18H6V19C6 20.6569 7.34315 22 9 22C10.6569 22 12 20.6569 12 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 19V5C12 3.34315 13.3431 2 15 2C16.6569 2 18 3.34315 18 5V6H19C20.6569 6 22 7.34315 22 9C22 10.6569 20.6569 12 19 12C20.6569 12 22 13.3431 22 15C22 16.6569 20.6569 18 19 18H18V19C18 20.6569 16.6569 22 15 22C13.3431 22 12 20.6569 12 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Brain03Icon;
